import { JSX, Show } from 'solid-js';
import { useSystemAssets } from '@bz/systemAssets';
import { useNavigate } from '@solidjs/router';

import { useBetSlipStore } from '../../useBetSlip';

import useNegativeEquity from '~/hook/useNegativeEquity';

export function NegativeEquity(): JSX.Element {
  const { isNegative, isCash, getNegativeDepositUrl, isNegativeCurrent } = useNegativeEquity();
  const [_, dispatch, , settingExpanded] = useBetSlipStore();
  const [assets] = useSystemAssets();
  const navigate = useNavigate();

  return (
    <Show when={isNegativeCurrent()}>
      <div class="w-full flex z-50 flex-col absolute top-16 left-0 right-0 bottom-0">
        {/* 遮罩层 - 单独一层，可以设置透明度 */}
        <div class="absolute inset-0 bg-layer3 opacity-80" />

        {/* 内容层 - 独立于遮罩层，保持完全不透明 */}
        <div class="relative flex-grow center flex-col"></div>

        {/* 底部内容 - 同样独立，保持不透明 */}
        <div class="relative w-full h-80 bg-layer5-card center text-white font-semibold p-6 flex-col text-center">
          <img
            src={assets.betlimitexceededCombo}
            class="mb-4"
            alt="Negative Equity"
            style={{
              width: '100px',
              height: '100px',
            }}
          />
          <div class=" text-neutral-main1 text-sm font-semibold">{t('Deposit Required')}</div>
          <div class=" text-neutral-main2 text-sm font-semibold">
            {t('Please clear your outstanding BRL balance before place new bets.')}
          </div>
          <Button
            class="h-11 w-full font-semibold mt-6"
            type="brand"
            onClick={() => {
              navigate(getNegativeDepositUrl());
            }}
          >
            {t('Deposit Now')}
          </Button>
        </div>
      </div>
    </Show>
  );
}
